import { render, staticRenderFns } from "./ques-contents.vue?vue&type=template&id=1b20d75e&scoped=true&"
import script from "./ques-contents.vue?vue&type=script&lang=js&"
export * from "./ques-contents.vue?vue&type=script&lang=js&"
import style0 from "./ques-contents.vue?vue&type=style&index=0&id=1b20d75e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b20d75e",
  null
  
)

export default component.exports